import { app } from '../../../../../../app';
import { Controller } from './import-users.controller';

app.component('companyUserDirectoriesDirectoryGroupsDirectoryImportUsers', {
    bindings: {companyId: '<'},
    controller: Controller,
    templateUrl: require('./import-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/import-users/import-users.component.js